export default __webpack_public_path__ + "static/media/NumPy.35ab7c33.png";